import client from '@/http'

const upload = (context, params) => {
  context.commit('SET_PROGRESS', 0)

  client.post(
    params.uri,
    params.payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        context.commit('SET_PROGRESS', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
      }
    }
  ).then(
    res => {
      context.commit('SET_FILE', res.data)
      context.commit('SET_PROGRESS', null)
    }
  ).catch(
    e => {
      console.error(e)
      context.commit('SET_FILE', null)
      context.commit('SET_PROGRESS', null)
    }
  )
}

const destroy = (context, file) => {
  client.delete(
    `/files/destroy/${file}`
  ).then(
    () => {
      context.commit('UNSET_FILE')
    }
  ).catch(
    e => {
      console.error(e)
    }
  )
}

export default {
  upload,
  destroy
}
